import { AUTO_DRAFT_OVERLAY_DEFAULT_OFFSET_X, AUTO_DRAFT_OVERLAY_VIEWPORT_MARGIN } from './auto-draft.constants';

/**
 * Horizontal offset to apply to the autodraft overlay so that its left edge lands
 * AUTO_DRAFT_OVERLAY_DEFAULT_OFFSET_X from the trigger's center, without leaving the viewport.
 *
 * @param originX Horizontal center of the trigger element, in viewport coordinates
 * @param overlayWidth Current width of the overlay
 * @param viewportWidth Width of the viewport (excluding scrollbars)
 */
export function getClampedOverlayOffsetX(originX: number, overlayWidth: number, viewportWidth: number): number {
  const desiredLeft = originX + AUTO_DRAFT_OVERLAY_DEFAULT_OFFSET_X;
  const maxLeft = viewportWidth - overlayWidth - AUTO_DRAFT_OVERLAY_VIEWPORT_MARGIN;
  // When the overlay is wider than the viewport there is no fitting position, so anchor it to the left edge
  const clampedLeft = Math.max(AUTO_DRAFT_OVERLAY_VIEWPORT_MARGIN, Math.min(desiredLeft, maxLeft));

  return Math.round(clampedLeft - originX);
}
